import { Dropdown, Form } from 'react-bootstrap';
import React from 'react';
import { FilterDto } from '../../../types/FilterDto';
import { useTranslation } from 'react-i18next';

interface CheckDropdownItemProps {
  label: string;
  id: string;
  checked: boolean;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
}

interface SelectFilterProps {
  filter: FilterDto;
  values: string[];
  onSelectChange: (name: string, value: string[], description: string) => void;
}

export default function MultipleSelectFilter({ filter, values, onSelectChange }: SelectFilterProps) {
  const { t } = useTranslation(['common','dashboard']);

  const handleSelectToggle = (selectedValue: string) => {
      const updatedValues = values.some(value => value == selectedValue)
        ? values.filter((val) => val !== selectedValue)
        : [...values, selectedValue];
      onSelectChange(filter.name, updatedValues, filter.description);
  };

  const CheckDropdownItem = React.forwardRef<HTMLDivElement, CheckDropdownItemProps>(
    ({ label, id, checked, onChange }, ref) => {
      return (
        <Form.Group ref={ref} className="dropdown-item mb-0" controlId={id}>
          <Form.Check
            type="checkbox"
            label={label}
            checked={checked}
            onChange={onChange}
          />
        </Form.Group>
      );
    }
  );

  return (
    <Form.Group controlId={`form${filter.name}MultipleSelect`}>
		<Form.Label>{t(filter.description)}</Form.Label>
		<Dropdown autoClose="outside" drop="down">
			<Dropdown.Toggle
				variant="light"
				id={`dropdown-${filter.name}`}
			>
				{t("dashboard:filters.selectDafaultTag", { filter: t(`${filter.description}`) }) }
			</Dropdown.Toggle>
			<Dropdown.Menu
        className="multi-select-dropdown-menu"
        align="start"
        renderOnMount
        popperConfig={{ strategy: 'fixed' }}
        style={{ overflow: 'auto', maxHeight: '450px' }}
      >
				{filter.values?.filter(value => value.key != null).map((value, index) => (
					<Dropdown.Item
						key={index}
						as={CheckDropdownItem}
						id={value.key as string}
						checked={values.some(x => x == value.key)}
						onChange={() => handleSelectToggle(value.key as string)}
						label={t(value.value as string)}
					/>
				))}
			</Dropdown.Menu>
      	</Dropdown>
    </Form.Group>
  );
}
